import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <g>
      <path
        d="M7,7 L3,7 L3,9 L7,9 L7,11 L10,8 L7,5 L7,7 Z M6,6 L6,5 C6,4.44771525 6.44771525,4 7,4 C7.26521649,4 7.5195704,4.10535684 7.70710678,4.29289322 L10.7071068,7.29289322 C11.0976311,7.68341751 11.0976311,8.31658249 10.7071068,8.70710678 L7.70710678,11.7071068 C7.31658249,12.0976311 6.68341751,12.0976311 6.29289322,11.7071068 C6.10535684,11.5195704 6,11.2652165 6,11 L6,10 L3,10 C2.44771525,10 2,9.55228475 2,9 L2,7 C2,6.44771525 2.44771525,6 3,6 L6,6 Z M13.5,3 C13.7761424,3 14,3.22385763 14,3.5 L14,12.5 C14,12.7761424 13.7761424,13 13.5,13 C13.2238576,13 13,12.7761424 13,12.5 L13,3.5 C13,3.22385763 13.2238576,3 13.5,3 Z"/>
    </g>
  </svg>
);
